import { apiService } from '../general/APIService';

const DIFFUSER_CLASSES_ENDPOINT = 'diffuser-classes';

export async function getDiffuserClasses() {
    const response = await apiService.get(DIFFUSER_CLASSES_ENDPOINT, { queryParams: { group: 'all' } });

    return response.data.data;
}
